import React from "react";
import ImgDeviceSelection from '../../../assets/images/device-selection.png'
import Breadcrumbs from "../../../components/Breadcumbs";

const pages = [
  { name: 'Devices', href: '', current: false },
]

export default function DevicesPage() {
  return (
    <>
      <Breadcrumbs pages={pages} />
      <div className="">
          <div className="grid place-items-center mt-40 md:mt-60">
              <img alt="PX1" src={ImgDeviceSelection} className="max-w-[50%]" />
          </div>
      </div>
    </>
  );
}
